import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-view-three-columns",
  templateUrl: "./med-icon-view-three-columns.component.html",
})
export class MedIconViewThreeColumnsComponent extends SvgMixinComponent {}
